module.exports = __webpack_public_path__ + "static/14-2b2203e7c0f22450e4522d08e9ee39b0.jpg";